/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import wrapRootComponent from "./src/wrapRootComponent"

export const wrapRootElement = wrapRootComponent
